<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template>
      <v-card flat>
        <v-expansion-panels class="pa-2">
          <v-expansion-panel
            v-for="(item, index) in computedValue.items"
            :key="index"
            class="mt-2 rounded-lg"
          >
            <v-expansion-panel-header>
              <span class="d-flex">
                <span class="my-auto">
                  {{ $t('question') + (index + 1) }}
                </span>
                <v-spacer />
                <div class="rowinfo justify-end">
                  <v-btn icon @click.stop="deleteFaq(index)">
                    <v-icon>mdi-delete</v-icon>
                  </v-btn>
                  <help-info
                    v-show="index === -1"
                    :element-name="`${serviceName}-${componentName}-data-Faq`"
                    :service-name="serviceName"
                    :help-data="helpData"
                    class="buttoninfo"
                    :label="$t('selected_question')"
                  />
                </div>
              </span>
            </v-expansion-panel-header>

            <v-expansion-panel-content class="mt-3">
              <div class="rowinfo">
                <v-text-field
                  v-model="item.question"
                  :hint="$t('question') + (index + 1)"
                  :label="$t('question') + (index + 1)"
                  clear-icon="mdi-close-circle-outline"
                  clearable
                  class="contnetinfo"
                  dense
                  outlined
                />
                <help-info
                  :element-name="`${serviceName}-${componentName}-item-question`"
                  :service-name="serviceName"
                  :help-data="helpData"
                  class="buttoninfo"
                  :label="$t('question')"
                />
              </div>

              <div class="col-md-12">
                <div class="rowinfo">
                  <suggest-text
                    v-model="item.answer"
                    :label="$t('answer')"
                    style="max-width: 100% !important; width: 100% !important"
                    rows="10"
                    class="contnetinfo"
                  />
                  <help-info
                    :element-name="`${serviceName}-${componentName}-item-question`"
                    :service-name="serviceName"
                    :help-data="helpData"
                    class="buttoninfo"
                    :label="$t('answer')"
                  />
                </div>
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>

        <v-card-actions class="px-6 pt-6">
          <div class="rowinfo" style="width: 100% !important">
            <v-btn color="success" outlined @click="addFaq" class="contentinfo">
              <v-icon>mdi-plus</v-icon>
            </v-btn>
            <help-info
              :element-name="`${serviceName}-${componentName}-data-addedFaq`"
              :service-name="serviceName"
              :help-data="helpData"
              class="buttoninfo"
              :label="$t('add_question')"
            />
          </div>
        </v-card-actions>
      </v-card>
    </template>
  </help-info-wrapper>
</template>

<script>
import SuggestText from "@/view/components/SuggestBox/suggestInput";

export default {
  name: "Faq",

  components: { SuggestText },

  props: {
    value: Object,
  },
  data() {
    return {
      helpData: [],
      serviceName: "Qrland",
      componentName: "Faq",
    };
  },
  computed: {
    computedValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },

  methods: {
    deleteFaq(index) {
      this.computedValue.items.splice(index, 1);
    },
    addFaq() {
      this.computedValue.items.push({ question: "", answer: "" });
    },
  },
};
</script>

<style scoped></style>
